<div #container class="nc-ripple-grid-canvas-container"></div>
<div class="nc-content-wrapper">
    <ng-content></ng-content>
</div>
